import React, { useState } from "react";
import { TextField, List, ListItem, ListItemText } from "@mui/material";
import { SERVER_BASE_URL } from "../Config";

interface SearchPatientProps {
  onSelect: (patient: any) => void;
  excludePatientIds?: number[]; // Optional array of patient IDs to exclude from results
}

const SearchPatient: React.FC<SearchPatientProps> = ({ onSelect, excludePatientIds = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState<any[]>([]);

  const onSelectPatient = (patient: any) => {
    setSearchTerm("");
    setResults([]);
    onSelect(patient);
  };

  const handleSearch = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);  // Update the searchTerm state with the current input

    const providerToken = localStorage.getItem("providerToken");

    const response = await fetch(`${SERVER_BASE_URL}/patient_lookup/${value}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${providerToken}`
      }
    });

    const data = await response.json();
    console.log(data["patients"]);
    // Filter out already selected patients
    const filteredResults = data["patients"].filter((patient: any) =>
      !excludePatientIds.includes(patient.id)
    );
    setResults(filteredResults);
  };

  return (
    <div>
      <TextField label="Search Patient" value={searchTerm} onChange={handleSearch} fullWidth margin="normal" />
      <List>
        {results.map(patient => (
          <ListItem key={patient.id} button onClick={() => onSelectPatient(patient)}>
            <ListItemText primary={`${patient.name} DOB: ${patient.dob}`} />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default SearchPatient;
